import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { LOCALE_ID } from '@angular/core';

import { LayoutComponent } from './layout/layout.component';

import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
import localePlExtra from '@angular/common/locales/extra/pl';

registerLocaleData(localePl, 'pl', localePlExtra);

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from 'src/app/auth/jwt.interceptor';
import { ErrorInterceptor } from './error.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { LoadingInterceptor } from './loading.interceptor';
import { CustomMaterialModule } from './material.module';
import { RedirectHomeComponent } from './redirect-home/redirect-home.component';
import { DataService } from './_services/data.service';
import { PrivilegesService } from './_services/privileges.service';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular-ivy';
import {NgxsModule} from '@ngxs/store';
import {JbpState} from './pages/joint-business-plan/state/jbp.state';
import {environment} from '../environments/environment';
import {NgxsFormPluginModule} from '@ngxs/form-plugin';

@NgModule({
  declarations: [AppComponent, LayoutComponent, RedirectHomeComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CustomMaterialModule,
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    NgxsModule.forRoot([JbpState], {
      developmentMode: !environment.production
    }),
    NgxsFormPluginModule.forRoot()
  ],
  providers: [
    { provide: LOCALE_ID, useValue: window.navigator.language },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    DataService,
    PrivilegesService,
    provideEnvironmentNgxMask(),
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: false,
    //   }),
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: () => () => {},
    //   deps: [Sentry.TraceService],
    //   multi: true,
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
